<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewClientDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      baseFormData: {
      },
      formData: {},
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
    this.formData.userCount = 10;
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('clientDetails', ['saveClient']),
    ...mapActions('clientList', { fetchData: 'fetchClientList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.saveClient(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Der Mandant wurde angelegt.');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/client/${data.id}`);
            }
          }
          this.fetchData();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmal.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neuer Mandant
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.name"
                :error-messages="validationErrorMessages.name"
                label="Bezeichnung"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.shortName"
                label="Kurzbez. für Benutzername"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md2 py-0>
              <v-checkbox
                v-model="formData.isActive"
                label="Aktiv"
                class="caption"
                hide-details
              />
            </v-flex>

            <v-flex xs12 md2 py-0>
              <v-checkbox
                v-model="formData.isDemo"
                label="Demo"
                class="caption"
                hide-details
              />
            </v-flex>

            <v-flex xs12 md2 py-0>
              <v-text-field
                v-model="formData.userCount"
                label="Max. Benutzerzahl"
                height="22"
                class="caption"
                mask="###"
              />
            </v-flex>

            <v-flex xs12 md12/>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.street"
                label="Straße"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md3 py-0>
              <v-text-field
                v-model="formData.zipCode"
                label="PLZ"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md3 py-0>
              <v-text-field
                v-model="formData.city"
                label="Stadt"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.country"
                label="Land"
                height="22"
                class="caption"
              />
            </v-flex>
            <v-flex xs12 md12>&nbsp;</v-flex>
            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.mobile"
                label="Mobil"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.phone"
                label="Telefon"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.fax"
                label="Fax"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.email"
                label="E-Mail"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.web"
                label="Website"
                height="22"
                class="caption"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; neu
              </v-list-tile-title>
            </v-list-tile>
            <!-- Does not work.
            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Details
              </v-list-tile-title>
            </v-list-tile>
            -->
          </v-list>
        </v-menu>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
